var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"AudioParser"},[_c('audio',{attrs:{"src":_vm.content,"controls":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }